export default "https://cdn-static.gokick.com/assets/96917af4b324ebd1ae50a0309f8a33967fe87b4d/images/sleep-tangerine.8751d74b530006d7d64194d2bb6c9716.png";